/** @jsxImportSource @emotion/react */
import { regExp } from "@/utils/formRegex";
import { Col, Form, Input } from "antd";
import { NovaventaInputCodeNumberCss } from "./NovaventaInputCodeNumberCss";

type Props = {
  position: number;
  formName: string;
};

export const NovaventaInputCodeNumber = ({ position, formName }: Props) => {
  return (
    <Col span={4}>
      <Form.Item
        name={`code${position}`}
        rules={[
          {
            required: true,
            pattern: regExp.justNumber,
            message: " "
          }
        ]}
      >
        <Input
          maxLength={1}
          css={NovaventaInputCodeNumberCss}
          type="text"
          onChange={({ target: { value } }) => {
            if (value && value.length === 1) {
              const item = document.getElementById(`${formName}_code${position + 1}`);
              if (item) item.focus();
            }
          }}
        />
      </Form.Item>
    </Col>
  );
};
